import React from 'react';

const PageHero = ({ label, title, description }) => (
  <section className="page-hero">
    <div className="page-hero__line" aria-hidden="true" />
    <div className="container page-hero__inner">
      <p className="eyebrow">{label}</p>
      <h1>{title}</h1>
      {description && <p>{description}</p>}
    </div>
  </section>
);

export default PageHero;
